<script setup>
import { ref, computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import FormFooter from './FormFooter.vue';

const emit = defineEmits(['sendMessage', 'cancel']);

const question = ref('');
const options = ref(['', '']);
const maxAnswer = ref('');

const addOption = () => {
  if (options.value.length >= 12) return;
  options.value.push('');
};
const removeOption = index => {
  if (options.value.length <= 2) return;
  options.value.splice(index, 1);
};

const cleanedOptions = computed(() =>
  options.value.map(option => option.trim()).filter(Boolean)
);

const isValid = computed(
  () => question.value.trim() && cleanedOptions.value.length >= 2
);

const submit = () => {
  if (!isValid.value) return;

  emit('sendMessage', {
    message: '',
    contentType: 'poll',
    contentAttributes: {
      data: {
        question: question.value.trim(),
        options: cleanedOptions.value,
        ...(maxAnswer.value ? { maxAnswer: Number(maxAnswer.value) } : {}),
      },
    },
  });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <Input
      v-model="question"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.POLL.QUESTION')"
    />
    <div class="flex flex-col gap-2">
      <label class="text-sm font-medium text-n-slate-11">
        {{ $t('CONVERSATION.EVOLUTION_INTERACTIVE.POLL.OPTIONS') }}
      </label>
      <div
        v-for="(option, index) in options"
        :key="index"
        class="flex items-center gap-2"
      >
        <Input v-model="options[index]" class="grow" />
        <NextButton
          v-if="options.length > 2"
          icon="i-lucide-x"
          ghost
          slate
          sm
          type="button"
          @click="removeOption(index)"
        />
      </div>
      <NextButton
        icon="i-lucide-plus"
        faded
        slate
        sm
        type="button"
        class="self-start"
        :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.POLL.ADD_OPTION')"
        @click="addOption"
      />
    </div>
    <Input
      v-model="maxAnswer"
      type="number"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.POLL.MAX_ANSWER')"
    />
    <FormFooter
      :disabled="!isValid"
      @cancel="$emit('cancel')"
      @submit="submit"
    />
  </div>
</template>
